export default [
  {
    title:
      'How I made the music for Fashion FUPA using two pieces of vintage audio gear',
    description:
      'Here I dive into my music composition process for the game Fashion FUPA. In order to capture the essence of two musical inspirations—90s freeware PC games, and the Nintendo Wii—I used a 90s General MIDI hardware module, whose sounds were used for both.',
    youtubeId: 'hPa7wosGhNs',
    vertical: true,
  },
  {
    title: 'Cassette: A declarative way to build media players for the web',
    description:
      'In this talk from the 2019 ForwardJS Ottawa conference, I present Cassette, a React component library that abstracts away much of the hassle building media players on the web. I discuss my design decisions, then live code a media player using Cassette.',
    youtubeId: 'fsySVdhEErI',
    vertical: false,
  },
]
